import React, { useRef } from 'react';
import loadable from '@loadable/component';
import Loading from '@components/Loading';
import ksBridge from '@ks/ks-bridge';
import {
  Dispatch,
  RootState,
  useRematchDispatch,
  useRematchState
} from '@/store';
import operation from '@/services/operation';

// import { triggerFMP } from '@/services/request';
import aioWeblog from '@aio/weblog';
import Home from '../modules/home';

// 按需加载 loading 效果
const AsyncComponent = loadable((props) => import(`../modules/${props.path}`), {
  fallback: <Loading />
});
const mapDispatch = (dispatch: Dispatch) => ({
  updateState: dispatch.home.updateState
});

const mapState = (state: RootState) => ({
  menus: state.home.menus,
  serviceMenus: state.home.serviceMenus
});
const Loadable = (key, path) => () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { updateState } = useRematchDispatch(mapDispatch);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { menus, serviceMenus } = useRematchState(mapState);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const hasRequestMenu = useRef(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const hasRequestServiceMenu = useRef(false);
  if (path === 'home') {
    const getMenu = async () => {
      if (hasRequestMenu.current) {
        return;
      }
      try {
        hasRequestMenu.current = true;
        const result = await operation.getMenu();
        updateState({
          menus: result
        });
      } catch (error) {
        //
      }
    };
    const { isIOS } = ksBridge.sniff;
    if (!isIOS && !menus.length) {
      getMenu();
    }
    const getServiceMenu = async () => {
      if (hasRequestServiceMenu.current) {
        return;
      }
      try {
        hasRequestServiceMenu.current = true;
        const result = await operation.getServiceMenu();
        aioWeblog.fmp();
        // if (api.queryServiceMenu.url) {
        //   triggerFMP(api.queryServiceMenu.url, key);
        // }
        updateState({
          serviceMenus: result
        });
      } catch (error) {
        //
      }
    };
    if (!serviceMenus.length) {
      getServiceMenu();
    }
    return <Home />;
  }
  return <AsyncComponent path={path} />;
};

export default Loadable;
